/**
 * TypeScript types for Process Simulation
 * Matches backend DTOs from Nexo.Core.Simulation namespace
 */

export interface SimulationResultDto {
  isSimulation: boolean;
  requestPath: string;
  requestMethod: string;
  originalStatusCode: number;
  executionTimeMs: number;
  entityChanges: EntityChangeDto[];
  eventsEmitted: SimulationEventDto[];
  rulesExecuted: RuleExecutionDto[];
  workflowsTriggered: string[];
  includedDraftRules: boolean;
  originalResponse?: unknown;
  errorMessage?: string;
  diagnostics: string[];
  stats?: SimulationStatsDto;
}

export interface EntityChangeDto {
  entityType: string;
  entityId?: string;
  changeType: string; // "Added" | "Modified" | "Deleted"
  propertyChanges: Record<string, PropertyChangeDto>;
}

export interface PropertyChangeDto {
  originalValue?: unknown;
  currentValue?: unknown;
}

export interface SimulationEventDto {
  eventType: string;
  eventData?: unknown;
  timestamp: string;
}

export interface RuleExecutionDto {
  ruleKey: string;
  ruleName: string;
  origin: string;
  passed: boolean;
  errorMessage?: string;
  /** C8: for a rule that did not pass, "Error" (it blocked) or "Warning" (advisory, the command proceeded). */
  severity?: 'Error' | 'Warning';
  isDraft: boolean;
}

/** A fired rule that the command proceeded through (C8). */
export const isAdvisory = (rule: Pick<RuleExecutionDto, 'passed' | 'severity'>): boolean =>
  !rule.passed && rule.severity === 'Warning';

export interface SimulationStatsDto {
  totalEntityChanges: number;
  totalEventsEmitted: number;
  totalRulesExecuted: number;
  rulesPassedCount: number;
  rulesFailedCount: number;
  draftRulesCount: number;
}
